import { elementsToMaxHeight } from '../helpers/elementsToMaxSizes'
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

let blockSlider = null
let sliderClass = '.block-properties-slider .element-slider'
function initPropertySlider() {

  if(!$(sliderClass).length) return false

  let slider = new Swiper(sliderClass, {
    modules: [ Navigation, Pagination, Autoplay ],
    slidesPerView: "auto",
    freeMode: true,
    loop: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: ' .element-slider-next',
      prevEl: ' .element-slider-prev'
    },
    pagination: {
      el: sliderClass + ' .swiper-pagination',
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return `<span class="${currentClass}"></span><span>/</span><span class="${totalClass}"></span>`
      }
    },
  })

  setTimeout(function () {
    elementsToMaxHeight($('.block-properties-slider .card-category-content'))
  }, 250)

}

initPropertySlider()
